import { useEffect, useRef, useState } from 'react';
import { useStore } from 'Store';
import STORAGE_KEYS from '../../../Storage/storageKeys';
import { PIN_BLOCKED_TIME } from '../../../options';

const useBlockedHandler = () => {
    const { appManager } = useStore();
    const storage = appManager.getStorage();
    const [isPinBlocked, setVarPinBlocked] = useState(false);
    const blockedTimer = useRef(null);

    const getBlockedData = async () => {
        const { data: blockedTimeMs } = await storage.getItem(STORAGE_KEYS.PIN_BLOCKED);
        const currentTime = new Date().getTime();
        if (blockedTimeMs > currentTime) setPinBlocked(blockedTimeMs - currentTime);
    };

    const setBlockedData = async () =>
        storage.setItem(STORAGE_KEYS.PIN_BLOCKED, {
            data: new Date().getTime() + PIN_BLOCKED_TIME
        });

    const setPinBlocked = (customTime) => {
        setVarPinBlocked(true);
        blockedTimer.current = setTimeout(
            () => setVarPinBlocked(false),
            customTime || PIN_BLOCKED_TIME
        );
        setBlockedData();
    };

    useEffect(() => {
        getBlockedData();

        return () => {
            clearInterval(blockedTimer.current);
        };
    }, []);

    return { isPinBlocked, setPinBlocked };
};

export default useBlockedHandler;
